module.exports = __webpack_public_path__ + "img/kazunari.1efbf09d.jpg";